import { useTranslation } from 'react-i18next';

import { Text } from '@bonusly/design-system';

import type { ConnectorKey } from '../../queries/connectors';

interface ConnectorAccessNoteProps {
	connector: ConnectorKey;
}

// Plain-language "what this connector reads" caption for the per-user
// connect cards (BIZY-749). Sourced from `connectorReadSummary`, a dedicated
// single-sentence, second-person copy set — distinct from `connectorAccess`,
// which stays third-person and unlabeled for the admin connectors table.
// The two intentionally diverge in phrasing (a full sentence here vs. short
// table-cell fragments there), so they're kept as separate i18n keys rather
// than reusing one string in two grammatical shapes.
export const ConnectorAccessNote = ({ connector }: ConnectorAccessNoteProps) => {
	const { t } = useTranslation('bizy_settings', { keyPrefix: 'connectorReadSummary' });

	return (
		<Text fontSize="xs" color="text.softest" mt={2}>
			{t(connector)}
		</Text>
	);
};
